import './preprocessDyson';
import { useRef, useCallback } from 'react';
import { useAsset } from '@artica/assets';
import { parallax } from '@immutabl3/alchemy/three';
import { PerspectiveCamera } from '@react-three/drei';
import {
  useSetRef,
  useManagedAnimations,
} from '@artica/hooks';

export default function DysonCamera() {
  const { nodes, animations } = useAsset('dyson');
  
  const group = useRef();
  const { actions } = useManagedAnimations(animations, group);

  const onPercChange = useCallback(perc => {
    const animation = actions?.animation_0;
    if (!animation) return;
    const mixer = animation.getMixer();
    const { duration } = animation.getClip();
    const sec = duration * perc;
    mixer.setTime(sec);
  }, [actions]);

  return (
    <parallax.group
      ref={ group }
      dispose={ null }

      beaker="chapter2"
      onPercChange={ onPercChange }
    >
      <PerspectiveCamera
        ref={ useSetRef('dysoncamera') }
        name="Camera"
        makeDefault={ true }
        far={ 50000 }
        near={ 1 }
        fov={ 29.86 }
        position={ [1149.14, 1914.85, -26.68] }
        rotation={ [-1.65, 0.59, 0.18] }
      />

      <mesh
        ref={ useSetRef('dysonsphere') }
        name="focusObj"
        visible={ false }
        geometry={ nodes.focusObj.geometry }
      />
    </parallax.group>
  );
};